import { ADD_ALERT, REMOVE_ALERT } from "./types";
import { v4 as uuidv4 } from "uuid";

export const setAlert =
  (message, alertType, timeout = 5000) =>
  (dispatch) => {
    const id = uuidv4();
    dispatch({ type: ADD_ALERT, payload: { message, alertType, id } });
    setTimeout(
      () =>
        dispatch({
          type: REMOVE_ALERT,
          payload: id,
        }),
      timeout
    );
  };

export const removeAlert = (id) => (dispatch) => {
  dispatch({
    type: REMOVE_ALERT,
    payload: id,
  });
};
